import createRequestWrapper from '@/utils/functions/wordpress/utils/create-request-wrapper';

const optimizeWpRequest = {
    events: createRequestWrapper(2),
    posts: createRequestWrapper(12),
    webinars: createRequestWrapper(12),
};

export default optimizeWpRequest;
